import {extractMessageFromException} from '../../utils/helpers'

export const getUserInfo = () => {
  return new Promise(function(resolve, reject) {
    let options = {
      async: true,
      headers: {'cache-control': 'no-cache'},
      callback: resolve,
      errorHandler: function(message, exception) {
        let extractedMessage = extractMessageFromException(exception)
        reject(extractedMessage)
      }
    }

    AdminService.getUser(options)
  })
}
